import React from 'react'
import { mkWidget, Action, Pair, async } from 'widgets-for-react'
import { CustomPagesState, PublicSiteCustomRoutes } from './public_site/custom_pages/types.mod'
import { CustomRouteParams } from './cms/router/type.gen'
import { PublicSiteState } from './public_site.main.mod'
import { WordPress } from './wordpress/wordpress_api'
import { AxiosResponse } from 'axios'
import { t } from 'i18next'
import { SearchForm } from './public_site/templates/searchbar'
import { Link } from 'react-router-dom'
import { toRelativeUrl, stripHTMLTags, gtmPush } from '../helpers'

function capitalizeFirst(s : string) : string {
  return s.charAt(0).toUpperCase() + s.slice(1)
}

function fixFaqLink(url: string, slug: string) : string {
  return url.replace(`/${slug}`, `#${slug}`)
}

const searchResults = (
  s0: Pair<CustomRouteParams<PublicSiteState, PublicSiteCustomRoutes>, CustomPagesState['search']>
) =>
  mkWidget({
    run: (setState: (_: Action<CustomPagesState['search']>) => void) => {

      if (s0.snd.header.searchValue && s0.snd.results.kind == 'loaded') {
        gtmPush({ 
          category: 'Search', 
          action: s0.snd.results.value.status == 200 && s0.snd.results.value.data ? 'Result' : 'No result', 
          label: s0.snd.header.searchValue 
        })
      }


      // LEGACY CODE: classnames and html is not being improved
      return <div className="page page--results results">
          <div className="results__top container container--m grid--block">
            <div className="section__head">
              <header className="results__ph">
                <h1 className="results__title typo--l">{ t('searchResults.title') }</h1>
              </header>
            </div>
            <div className="section__body">
                <SearchForm
                  searchValue={s0.snd.header.searchValue}
                  updateSearchValue={e =>
                    setState(s1 => ({
                      ...s1,
                      header: { ...s1.header, searchValue: e }
                    }))
                  }
                  label={t('searchResults.formLabel')}
                />

            </div>
          </div>
        <section className="search-results container container--m">
          <div className="search-results__inner grid--block">

            <div className='search-results__content'>
              { s0.snd.header.searchValue == '' ?
                <p>Je hebt geen zoekterm opgegeven.</p>
              : s0.snd.results.kind != 'loaded' ? (
                <div className="loader loader--page">
                  <div className="loader__inner">
                    <svg className="loader__icon" width="60px" height="60px" aria-hidden="true">
                      <use xlinkHref="#icon--loader" />
                      <span className="sr-only">Loading...</span>
                    </svg>
                  </div>
                </div> 
              ) : (s0.snd.results.value.status == 200 && s0.snd.results.value.data) ? (
                <ul className='results__list'>
                  { s0.snd.results.value.data.map(search_result => {
                    let parsed_excerpt: string = search_result.excerpt.rendered ? stripHTMLTags(search_result.excerpt.rendered) : null
                    if (parsed_excerpt && parsed_excerpt.startsWith(search_result.title.rendered)) {
                      parsed_excerpt = parsed_excerpt.substr(search_result.title.rendered.length)
                    }
                    parsed_excerpt = parsed_excerpt ? `<p>${parsed_excerpt.replace(s0.snd.header.searchValue, `<b>${s0.snd.header.searchValue}</b>`)}</p>` : null
                    return <li className="result">
                        <Link to={ search_result.type == 'faq' ? `/faq#${search_result.slug}` : toRelativeUrl(search_result.link)} className='result__link'>
                        { search_result.type && 
                          <span className="result__label">{ t(`searchResults.types.${search_result.type}`) }</span> 
                        }
                        <div className="result__copy">
                          <h3 className="result__title typo--m" dangerouslySetInnerHTML={{__html: search_result.title.rendered}}/>
                        </div>
                        { parsed_excerpt &&
                          <div className="result__description" dangerouslySetInnerHTML={{__html: parsed_excerpt}}/>
                        }
                      </Link>
                    </li>
                  })}
                </ul>
              ) : (
                <div className="container contianer--m text--styled">
                  <p>Geen resultaten gevonden. Probeer het opnieuw met deze tips:</p>
                  <ul>
                    <li>Controleer je spelling</li>
                    <li>Omschrijf je zoekopdracht anders</li>
                    <li>Maak je zoekopdracht korter</li>
                  </ul>
                </div>
              )}
            </div>
          </div>

          {async<AxiosResponse<WordPress.PostTypeResponse[]>>()(s0.snd.results).run(
            (a0: Action<CustomPagesState['search']['results']>) => {
              setState(s1 => {
                return { ...s1, results: a0(s1.results) }
              })
            }
          )}
        </section>
      </div>
    }
  })

export { searchResults }



// WEBPACK FOOTER //
// ./Client/components/searchResults.tsx